// extracted by mini-css-extract-plugin
module.exports = {"component":"cursor_component__JjNVb","ball":"cursor_ball__1tj89"};